// extracted by mini-css-extract-plugin
module.exports = {"socialShareWraper":"SocialSection_socialShareWraper__3V1lE","shareButtons":"SocialSection_shareButtons__2Uvwz"};